module.exports = __webpack_public_path__ + "static/media/galerija_2017 (4).a99b988e.jpg";